module.exports = __webpack_public_path__ + "static/media/hotels.620f7322.png";